import { render } from "./UserUpdatePhoto.vue?vue&type=template&id=07dbf2ba&scoped=true"
import script from "./UserUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./UserUpdatePhoto.vue?vue&type=script&lang=js"

import "./UserUpdatePhoto.vue?vue&type=style&index=0&id=07dbf2ba&scoped=true&lang=css"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07dbf2ba"]])

export default __exports__